import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxMois extends Component {

    static defaultProps = {
        label: "Mois",
        placeholder: "Mois",
        onDesactiveMoisSuperieursDateJour: false,
    };


    render = () => {

        const { onDesactiveMoisSuperieursDateJour } = this.props;
        const moisEnCours = new Date().getMonth() + 1;

        const fetchMethod = () => new Promise((resolve, reject) => {
            const months = Scriba.traduction().stringsTermes().fr.DayPickerStrings.months.map((month, index) => ({ key: index + 1, text: month }));
            resolve({ codeRetour: 0, reponseAPIobjet: months });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemDisabled={item => onDesactiveMoisSuperieursDateJour && item.key > moisEnCours}
        />;

    };

};